module.exports = __webpack_public_path__ + "media/src/img/youtube_logo_light-5a7228d0b9db55b01dec3cddcbb3d4afcdbdabb63b7779b2a1fea0d40fa24c64.png";